import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from '../constants/api.constants';
import { DailyReportBulkRequest, DailyReportCell } from '../interfaces/daily-report.interface';

@Injectable({
  providedIn: 'root'
})
export class DailyReportService {
  private apiUrl = `${API_CONFIG.BASE_URL}/daily-report`;

  constructor(private http: HttpClient) {}

  /**
   * Napi riport cellák lekérdezése több felhasználóra, egy kérésben
   */
  getBulkReport(request: DailyReportBulkRequest): Observable<DailyReportCell[]> {
    return this.http.post<DailyReportCell[]>(`${this.apiUrl}/bulk`, request);
  }

  /**
   * Az adott nap összes táblázatának exportálása egy XLSX fájlba
   */
  exportReport(request: DailyReportBulkRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/export`, request, { responseType: 'blob' });
  }
}
